import { Component, OnInit } from '@angular/core';
import { BillingControlService } from '../service/billing-control.service';

@Component({
  selector: 'app-bc-largest-debtors',
  templateUrl: './bc-largest-debtors.component.html',
  styleUrls: ['./bc-largest-debtors.component.scss']
})
export class BcLargestDebtorsComponent implements OnInit {

  private BcLargestData = [];
  private BcLargestTotal = 0;

  //Chart Configuration and Data
  private hasLegend = 'true'
  private chartType = 'pie'
  private chartData = [{ data: [] }];
  private chartLabels = [];
  private showChart = false;
  private isLoaded = false;
  private showAll = false;

  constructor(private billingControlService: BillingControlService) {
  }

  ngOnInit() {
  }

  onOpenAccordion() {
    if (this.isLoaded == false) {
      this.getBCLargest();
    }
  }

  getBCLargest() {
    this.billingControlService.getBCLargest(this.showAll).subscribe(result => {
      if (result.Success) {
        this.BcLargestData = result.Result || [];
        this.BcLargestTotal = result.Total;
        this.isLoaded = true;
        this.defineChartByData();
      } else {
        console.log("Erro ao carregar dados!");
      }
    }, error => {
      console.log(error);
    });
  }

  defineChartByData() {
    if (this.BcLargestData.length > 1) {
      this.BcLargestData.forEach((row, index) => {
        this.addChartData(row.Nome, row.Percentual);
        if (index == this.BcLargestData.length - 1) {
          this.showChart = true;
        }
      });
    }
  }

  addChartData(label, data) {
    const tempChartData = this.chartData[0].data;
    tempChartData.push(data);
    this.chartData[0].data = tempChartData;
    this.chartLabels.push(label);
  }

  onShowAll() {
    this.showAll = true;
    this.getBCLargest();
  }

  onShowLess() {
    this.showAll = false;
    this.getBCLargest();
  }
}



// WEBPACK FOOTER //
// ./src/app/billing-control/billing-control/bc-largest-debtors/bc-largest-debtors.component.ts